import React from 'react';
import { Card, Col, Button, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import usePermission from 'components/common/usePermission';

const BlogHeader = () => {
  const { authorized, styles } = usePermission('B11');
  return (
    <Card>
      <Card.Body>
        <Row className="flex-between-center">
          <Col md>
            <h5 className="mb-2 mb-md-0">Шинэ мэдээ</h5>
          </Col>
          <Col xs="auto">
            <Button
              variant="link"
              className="text-secondary fw-medium p-0 me-3"
              type="button"
            >
              цуцлах
            </Button>
            <Button
              as={Link}
              to="/blogs/new-blog"
              variant="primary"
              size="sm"
              style={styles}
              disabled={authorized}
            >
              Мэдээлэл нэмэх
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default BlogHeader;
